var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('SubmitOfferPage'),_c('SnackbarMessages',{attrs:{"messages":_vm.$root.$data.state.messages,"clickMessage":function (index) { return _vm.$root.$data.readMessage(index); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }